<template>
  <div class="dropzone">

    <div id="upload">
      <!-- 表格区域 -->
      <vxe-grid ref='xGrid' v-bind="gridOptions" @edit-disabled="editDisabledEvent" @cell-dblclick="noEdit"
        @checkbox-change="checkboxChangeEvent" @checkbox-all="checkboxChangeEvent">

        <template #tools>
          <div style="display: flex;gap: 10px;">
            <el-upload class="upload-demo" action="" :before-upload="upLoad" :show-file-list="false"
              style="display: inline-block;" :disabled="!addBtnPriv || !addBtn" :multiple="true" :limit="10">
              <el-button class="btn btn1" icon="el-icon-circle-plus-outline" :disabled="!addBtnPriv || !addBtn">{{
                $t('message.button.add') }}</el-button>
            </el-upload>

            <el-button class="btn btn2" icon="el-icon-delete" @click="removeAttachment"
              :disabled="!removeBtnPriv || !removeBtn">
              {{ $t('message.button.delete') }}
            </el-button>

            <el-button class="btn btn3" style="margin-left: 0;" icon="el-icon-paperclip" @click="downloadAttachment"
              :disabled="!fileBtnPriv">
              {{ $t('message.button.download') }}
            </el-button>

            <el-button class="btn btn4" style="margin-left: 0;" icon="el-icon-reading" @click="previewFile"
              :disabled="!fileReadBtnPriv">
              {{ $t('message.button.preview') }}
            </el-button>

            <div class="edit-table" style="float: right;overflow: hidden;height: 33px;">
              <el-button class="btn btn7" icon="el-icon-document-checked" @click="saveValue">{{
                $t('message.button.save')
              }}</el-button>
              <el-button class="btn btn8" icon="el-icon-circle-close" @click="cancelSave">{{
                $t('message.button.cancel')
              }}</el-button>
            </div>
          </div>
        </template>
        <template #bottom>
          <div class="alert-message">
            <span class="alert-message-content">
              <div>{{ $t('message.title.Checked') + selectRecords.length + $t('message.title.resultsNums') }} {{
                $t('message.title.totalResults') + totalRecords + $t('message.title.resultsNums') }}</div>
            </span>
          </div>
        </template>
        <template #empty>
          <empty />
        </template>
      </vxe-grid>
    </div>

    <el-dialog :title="$t('message.tips.upLoad')" :visible.sync="upLoadDialog" width="30%" height="50%"
      :before-close="handleClose" :close-on-click-modal="false" :close-on-press-escape="false">
      <!-- <span>上传速度：{{upLoadSpeed}}(KB/S)</span> -->
      <el-progress :text-inside="true" :stroke-width="16" :percentage="upLoadProgress" status="success"></el-progress>
      <!-- <span slot="footer" class="dialog-footer">
  <el-button @click="upLoadDialog = false;dialogCloseBtn = true" :disabled="dialogCloseBtn">关闭</el-button>
</span> -->
    </el-dialog>

    <el-dialog v-if="cascaderShow" class="searchAddBomList" :title="$t('message.title.add')"
      :visible.sync="cascaderShow" @close="closeCascaderShow">
      <div style="height:270px;">
        <div style="margin:60px auto;padding-left:50px">
          <el-cascader v-model="cascaderValue" :options="cascaderList" :props="cascaderProps" :show-all-levels="true"
            size="small" ref="cascaderAddr" style="width:75%"></el-cascader>
          <el-button size="small" type="primary" style="margin-left:10px" @click="getCascadeValue">{{
            $t("message.button.affirm") }}</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<style>
.searchAddBomList .el-dialog__body {
  padding: 0 20px 20px 20px !important;
}

.el-table th.gutter {
  display: table-cell !important;
}

.link_ {
  color: #4b92ff;
  cursor: pointer;
}

.link_:hover {
  color: #4b92ff;
  cursor: pointer;
  border-bottom: 1px solid #4b92ff;
}
</style>

<script>
import axios from "axios";
import { Base64 } from "js-base64";
import Empty from "../../item/empty.vue";
// import { getNewRedLineTableContentData, getNewTableTitleData, gridOptions, setListEntry } from "./affectItemConfig";

export default {
  data() {
    return {
      dialogClosedUploadId: "",

      obsKey: "",

      upLoadProgress: 0,
      upLoadDialog: false,//上传

      dialogCloseBtn: true,
      // save_img1 : require("@/assets/save1.png"),
      // save_img2 : require("@/assets/save2.png"),

      selectRecords: [],
      totalRecords: "",
      gridOptions: {
        keepSource: true,
        resizable: true,
        border: true,
        stripe: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        rowId: 'id',
        height: "250",
        size: "small",
        columns: [{
          type: 'checkbox',
          width: 50,
          fixed: null
        }],
        data: [],
        toolbarConfig: {
          zoom: true,
          custom: true,
          print: true,
          slots: {
            buttons: "tools",
          },
        },
        printConfig: {},
        treeConfig: {
          lazy: true,
          children: 'children',
          hasChild: 'hasChildren',
          loadMethod: this.loadChildrenMethod
        },
        editConfig: {
          trigger: 'dblclick',
          mode: 'row',
          showIcon: false,
          activeMethod: this.activeRowMethod,
          showStatus: true,
        },
        sortConfig: {
          trigger: 'cell'
        },
      },
      cols: [], //表头
      editShow: false,

      //权限
      removeBtnPriv: false,
      fileBtnPriv: false,
      addBtnPriv: false,
      fileReadBtnPriv: false,

      // //btn业务逻辑
      addBtn: false,
      removeBtn: false,

      get_change_info: "", //父组件传来的值

      cascaderShow: false,
      cascaderValue: [],
      cascaderList: [],
      cascaderProps: {}
    }
  },
  components: { Empty },
  mounted() {
    const dropzone = document.querySelector(".dropzone");
    dropzone.addEventListener("dragover", (event) => {
      event.target.classList.add("fileshover");
      event.preventDefault(); //阻止默认行为，允许放置
    });

    dropzone.addEventListener("drop", (event) => {
      if (!this.addBtnPriv || !this.addBtn) {
        this.$message.error('请检查是否有此权限')
        event.preventDefault();
        return;
      }
      const dataTransferItemList = event.dataTransfer.items;
      for (const dataTransferItem of dataTransferItemList) {
        const file = dataTransferItem.webkitGetAsEntry();
        this.handlefile(file);
      }
      event.preventDefault(); //阻止浏览器默认行为，不会自动打开文件管理页面
    });
  },
  methods: {
    handlefile(file) {
      if (file.isFile) {
        // 是文件执行上传操作
        //file.file() 方法用于读取文件内容
        file.file((f) => {
          // f才是最终的文件
          this.upLoad(f);
          // const text = document.createTextNode(f.name + '—');
          // dropzone.appendChild(text);
          return;
        });
      } else {
        const dirReader = file.createReader();
        dirReader.readEntries((entries) => {
          for (let i = 0; i < entries.length; i++) {
            this.handlefile(entries[i]);
          }
        });
      }
    },

    checkboxChangeEvent({
      records
    }) {
      const $grid = this.$refs.xGrid;
      this.selectRecords = records;
    },
    handleClose(done) {
      var vm = this;
      this.$confirm(vm.$t('message.confirm.close')).then(_ => {
        vm.upLoadDialog = false;
      }).catch(_ => { });
    },
    addAttachment() {
    },

    upLoad(file) {
      var vm = this;
      let fd = new FormData();

      // var change_info = this.$store.state.change_info;
      // if (this.get_change_info == "") {
      //   change_info = this.$store.state.change_info;
      // } else {
      //   change_info = this.get_change_info;
      // };

      var objInfo = this.dataInfo;

      //fd.append('file',file);
      fd.append('id', objInfo.id);
      fd.append('classId', objInfo.classId);
      fd.append('subClassId', objInfo.subClassId);
      fd.append("changeId", objInfo.changeId);
      fd.append("changeClassId", objInfo.changeClassId);
      fd.append("changeSubClassId", objInfo.changeSubClassId);
      fd.append('fileName', file.name);
      fd.append('fileSize', file.size);


      // var bucketName = document.getElementById('bucket4upload');
      // var objectKey = document.getElementById('key4upload');
      // var file = document.getElementById('files').files[0];


      var path = window.sessionStorage.getItem("tenantName") + '/' + objInfo.classId + '/' + objInfo.subClassId +
        '/' + objInfo.id + '/' + objInfo.changeId + '/' + file.name;
      fd.append('path', path);
      vm.obsKey = path;

      axios.post('/swift-file/files/checkFileNameAndRev', fd).then(function (res) {
        if (res.data.object.code == 501) {
          vm.$confirm(vm.$t('message.confirm.overwrite'), res.data.object.fileName, vm.$t('message.tips.tip'), {
            confirmButtonText: vm.$t('message.button.affirm'),
            cancelButtonText: vm.$t('message.button.cancel'),
            type: 'warning'
          }).then(() => {
            vm.updateFile(file, fd, res.data.object.url);
          }).catch(() => {
            vm.$message({
              type: 'info',
              message: vm.$t('message.tips.cancel')
            });
          });
        } else if (res.data.object.code == 200) {
          vm.updateFile(file, fd, res.data.object.url);
        } else {
          vm.$message.error(res.data.object.message);
          return false;
        };
      });
    },
    updateFile(file, fd, url) {
      let vm = this;
      if (file.size == 0) {
        this.upLoadDialog = false; //当附件大小为0KB时，不显示进度条
      } else {
        this.upLoadDialog = true; //展示进度条
      }
      var reopt = {
        method: "PUT",
        url: url,
        withCredentials: false,
        headers: { 'Content-Type': 'application/octet-stream' },
        validateStatus: function (status) {
          return status >= 200;
        },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.lengthComputable) {
            var complete = (((progressEvent.loaded / progressEvent.total) * 100) | 0);
            for (let index = 0; index < 81; index++) {
              vm.upLoadProgress = index;
            }
            if (complete >= 100) {
              vm.upLoadDialog = false;
              vm.upLoadProgress = 0; // 重新置0
            };
          }
        },
        maxRedirects: 0,
        data: file,
      };

      axios.request(reopt).then(function (response) {
        if (response.status = 200 && response.data == "") {
          axios.post('/swift-file/files/uploadFileMetadata', fd).then(function (res) {
            if (res.data.code == 200) {
              vm.$message({
                message: vm.$t('message.title.attachment') + file.name + vm.$t('message.success.upLoad'),
                type: 'success'
              });
              vm.getAttachments();
            }
          });
        } else {
          vm.$message.error(vm.$t('message.error.add'));
        };
      }).catch(function (err) {
        vm.$message.error(vm.$t('message.error.add'));
      });
    },
    removeAttachment() {
      var removeRow = this.$refs.xGrid.getCheckboxRecords();
      let deletedFilesId = [];
      var vm = this;
      if (removeRow.length == 0) {
        vm.$message({
          message: this.$t('message.tips.dele_data'),
          type: "warning",
        });
      } else {
        this.$confirm(this.$t('message.confirm.deleteData'), this.$t('message.tips.tip'), {
          confirmButtonText: this.$t('message.button.affirm'),
          cancelButtonText: this.$t('message.button.cancel'),
          type: 'warning'
        }).then(() => {
          for (var i = 0; i < removeRow.length; i++) {
            deletedFilesId.push(removeRow[i].fileId);
          };
          axios.post('/swift-file/files/deleteFile', deletedFilesId).then(function (res) {
            if (res.data.code == 200) {
              vm.$message({
                message: res.data.message,
                type: 'success'
              });
              vm.getAttachments();
            }
          }).catch(function (error) {
          });

        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('message.tips.deleteCancel')
          });
        });
      }
    },

    previewFile() {
      var previewFileRow = this.$refs.xGrid.getCheckboxRecords();
      // var downloadFilesId = [];
      var vm = this;
      if (previewFileRow.length == 0) {
        return false
      }
      else if (previewFileRow.length > 1) {
        vm.$message({
          message: this.$t('message.warning.choice'),
          type: "warning",
        });
      }
      else {
        // var getFile = {
        //   fileId: previewFileRow[0].fileId,
        //   type: 'preview',//preview 不在记录在历史tab，所以有些参数没传
        // };
        var change_info = this.$store.state.change_info;
        if (this.get_change_info == "") {
          change_info = this.$store.state.change_info;
        } else {
          change_info = this.get_change_info;
        };

        var getFile = {

          ... this.$store.state.objectId,
          //id: this.$store.state.objId_,
          //classId: this.$store.state.classId_,
          //subClassId: this.$store.state.subClassId_,
          changeId: change_info.changeId,
          changeClassId: change_info.changeClassId,
          changeSubClassId: change_info.changeSubClassId,
          fileId: previewFileRow[0].fileId,
          fileName: previewFileRow[0][0],
          type: 'preview',//新加的参数是给记录到历史tab里用
        };

        axios.post(`swift-file/files/getFileDownloadUrl`, getFile).then(res => {
          var path = res.data.object.path;
          var preLink = res.data.object.previewUrl
          var url = path;
          var iWidth = window.screen.width - window.screen.width / 3;                          //弹出窗口的宽度;
          var iHeight = window.screen.height;                                                 //弹出窗口的高度;
          var iTop = 50;
          var iLeft = (window.screen.width - iWidth) / 2;
          window.open(preLink + '/onlinePreview?url=' + encodeURIComponent(Base64.encode(url)), '_blank', 'height=' + iHeight + ',width=' + iWidth + ',top=' + iTop + ',left=' + iLeft + '');
        })
      }
    },

    // downloadAttachment() {
    //   let vm = this;
    //   var downloadRow = this.$refs.xGrid.getCheckboxRecords();
    //   if (downloadRow.length == 0) {
    //     return false
    //     // } else if (downloadRow.length > 1) {
    //     //   vm.$message({
    //     //     message: this.$t('message.warning.choice'),
    //     //     type: "warning",
    //     //   });
    //   } else {
    //     var change_info = this.$store.state.change_info;
    //     if (this.get_change_info == "") {
    //       change_info = this.$store.state.change_info;
    //     } else {
    //       change_info = this.get_change_info;
    //     };
    //     var getFile = {
    //       ... this.$store.state.objectId,
    //       //id: this.$store.state.objId_,
    //       //classId: this.$store.state.classId_,
    //       //subClassId: this.$store.state.subClassId_,
    //       changeId: change_info.changeId,
    //       changeClassId: change_info.changeClassId,
    //       changeSubClassId: change_info.changeSubClassId,
    //       fileId: downloadRow[0].fileId,
    //       fileName: downloadRow[0][0],
    //       type: 'download',//新加的参数是给记录到历史tab里用
    //     };

    //     axios.get(`swift-file/files/getFileDownloadUrl${this.params(getFile)}`).then(res => {
    //       // var path = res.data.object.path;
    //       // this.downLoadFile(path, downloadRow[0][0]);
    //       if (res.data.code == 200) {
    //         let files = res.data.object;
    //         for (let i = 0; i < files.length; i++) {
    //           const xhr = new XMLHttpRequest();
    //           xhr.open("GET", files[i].path, true);
    //           xhr.responseType = "blob";
    //           xhr.onload = () => {
    //             const url = window.URL.createObjectURL(xhr.response);
    //             const a = document.createElement("a");
    //             a.href = url;
    //             a.download = files[i].fileName;
    //             a.click();
    //             a.remove();
    //           };
    //           xhr.send();
    //         }
    //       }
    //     })
    //   };
    // },
    downloadAttachment() {
      let downloadRow = this.$refs.xGrid.getCheckboxRecords();
      var download_table = [];

      if (downloadRow.length == 0) {
        return false;
      } else {
        for (let i = 0; i < downloadRow.length; i++) {
          download_table.push(downloadRow[i].rowId);
        }
        var objectId = downloadRow.map(i => {
          const { name, ...obj } = i.objectId
          return obj
        })
        var changeId = this.$store.state.objectId.id;

        var relationshipMapVo = {
          delIds: download_table,
          objectId: objectId[0],
          changeId,
        };

        // return

        axios
          .post("swift-file/files/getFileDownloadUrlByFileIdList", relationshipMapVo)
          .then((res) => {
            if (res.data.code == 200) {
              let files = res.data.object;
              for (let i = 0; i < files.length; i++) {
                const xhr = new XMLHttpRequest();
                xhr.open("GET", files[i].path, true);
                xhr.responseType = "blob";
                xhr.onload = () => {
                  const url = window.URL.createObjectURL(xhr.response);
                  const a = document.createElement("a");
                  a.href = url;
                  a.download = files[i].fileName;
                  a.click();
                  a.remove();
                };
                xhr.send();
              }
            }
          })
          .catch(function (error) {
          });
      }
    },
    downLoadFile(path, file_name) {
      let link = document.createElement('a');
      link.href = path;
      link.download = file_name;
      document.body.appendChild(link);
      link.click();         // 下载完成移除元素
      document.body.removeChild(link);
    },
    //拷贝downloadAttachment的代码，只是改了downloadRow，和getFile。fileId getFile。fileName
    clickRowDownloadAttachment(clickRow) {
      var downloadRow = clickRow;
      var downloadFilesId = [];
      var vm = this;
      if (downloadRow.length == 0) {
        return false
      } else if (downloadRow.length > 1) {
        vm.$message({
          message: this.$t('message.warning.choice'),
          type: "warning",
        });
      } else {
        var getFile = {
          id: downloadRow.itemId,
          classId: downloadRow.itemClassId,
          subClassId: downloadRow.itemSubClassId,
          // ...this.$store.state.objectId,
          //changeId: this.$store.state.objId_,
          changeId: this.$store.state.objectId.id,
          changeClassId: this.$store.state.objectId.classId,
          changeSubClassId: this.$store.state.objectId.subClassId,
          fileId: downloadRow.fileId,
          fileName: downloadRow[0],
          type: 'download',//新加的参数是给记录到历史tab里用
        };

        axios.post(`swift-file/files/getFileDownloadUrl`, getFile).then(res => {
          var path = res.data.object.path;
          fetch(path).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
            const a = document.createElement('a')
            a.href = URL.createObjectURL(blob);
            a.download = downloadRow[0];  // 下载文件的名字
            document.body.appendChild(a)
            a.click()
          })
        });
      }
    },
    noEdit({ row, columnIndex }) {
      let systemName = window.sessionStorage.getItem("systemName");
      if (systemName.indexOf('奥斯汀') != -1) {
        let fileNameIndex = 1;
        for (let k = 0; k < this.gridOptions.columns.length; k++) {
          if (this.gridOptions.columns[k].attid == this.Constants.attachmentFileName) {
            fileNameIndex = Number(this.gridOptions.columns[k].field) + 1;
          }
        }
        if (columnIndex == fileNameIndex) {
          this.clickRowDownloadAttachment(row);
        }
      }
      if (column.editRender.cascaderType && this.editTable) {
        this.cascaderList = column.editRender.cascadeOptions;
        let m = row[[column.property]];
        if (column.editRender.props.multiple) {
          this.cascaderValue = m ? m.map((i) => { return this.getParentIdList(this.cascaderList, i) }) : ''
          this.cascaderProps.multiple = true;
        } else {
          this.cascaderProps.multiple = false;
          this.cascaderValue = m;
        }
        this.cascaderProps.checkStrictly = true;
        this.tempData = { row, column }
        this.cascaderShow = true;
      }
    },
    saveValue() {
      var xGrid_ = this.$refs.xGrid;
      let updateRecords = this.$refs.xGrid.getUpdateRecords(); //获取修改的行
      var updateFile = [];
      if (updateRecords.length !== 0) { //判断行内那些值有改动
        for (let i = 0; i < updateRecords.length; i++) {
          var num = xGrid_.getRowIndex(updateRecords[i]);
          var cols_length = this.cols;
          for (let j = 0; j < cols_length.length; j++) {
            var updateNewData = xGrid_.isUpdateByRow(updateRecords[i], "" + j);
            if (updateNewData) {
              // var obj = {};
              // var quantity = cols_length[j];
              // obj.id = updateRecords[i].rowId;
              // obj[quantity] = updateRecords[i][j];
              // updateFile.push(obj);
              for (let k = 0; k < this.gridOptions.columns.length; k++) {
                var obj = {};
                if (cols_length[j] == this.gridOptions.columns[k].attid) {
                  var quantity = cols_length[j];
                  obj.id = updateRecords[i].rowId;
                  if (this.gridOptions.columns[k].editRender.props) {
                    //处理多选和单选
                    if (this.gridOptions.columns[k].editRender.props.multiple) {
                      obj[quantity] = updateRecords[i][j].join(";");
                    } else if (
                      this.gridOptions.columns[k].editRender.props.type ==
                      "datetime"
                    ) {
                      // obj[quantity] = updateRecords[i][j].format("yyyy-MM-ddThh:mm:ss");
                      obj[quantity] = this.format(
                        updateRecords[i][j],
                        "yyyy-MM-ddThh:mm:ss"
                      );
                    } else {
                      if (updateRecords[i][j] == null) {
                        obj[quantity] = "";
                      } else {
                        obj[quantity] = updateRecords[i][j];
                      }
                    }
                  } else {
                    if (updateRecords[i][j] == null) {
                      obj[quantity] = "";
                    } else {
                      obj[quantity] = updateRecords[i][j];
                    }
                  };
                  updateFile.push(obj);
                }
              }
            }
          }
        };
        var updateFileData = { //post更改的值
          tableId: 201,
          objId: {
            id: this.dataInfo.id,
            classId: this.dataInfo.classId,
            subClassId: this.dataInfo.subClassId,
            version: this.version
          },
          updateFile: updateFile
        };
        var vm = this;
        axios.post('pmdm/items/updateTable', updateFileData)
          .then(function (res) {
            if (res.data.code == 200) {
              vm.$message({
                message: res.data.message,
                type: 'success'
              });
              vm.getAttachments();
              xGrid_.revertData();
            }
          })
          .catch(function (error) {
          });
      };
    },
    cancelSave() {
      this.$refs.xGrid.revertData(); //清除所有保存，删除，添加记录
    },
    editDisabledEvent() {

    },
    async getAttachments() {
      // var change_info = this.$store.state.change_info;
      // if (this.get_change_info == "") {
      //   change_info = this.$store.state.change_info;
      // } else {
      //   change_info = this.get_change_info;
      // };
      if (this.dataInfo.id == undefined) return false;
      var obj_get = this.dataInfo;
      var loadTableUrl = `pmdm/items/loadTable${this.params(obj_get)}`;
      const { //获取标题
        data: res
      } = await this.$http.get(loadTableUrl);
      this.gridOptions.columns = this.getNewTableTitleData(res);
      this.rols_text = this.getNewTableContentData(res);
      this.gridOptions.data = this.rols_text;
      this.totalRecords = res.object.table.totalRecords;
      this.cols = res.object.table.columnInfo.ids;
      this.selectRecords = [];
    },
    loadUserPriv() {

      this.getPriv().then(res => {

        const { hasPriv = '', fileAddPriv, delPriv, downLoadPriv, previewPriv } = res.data.object

        // this.addBtn = !this.dataInfo.isrelase;
        // this.removeBtn = !this.dataInfo.isrelase;
        this.addBtn = this.dataInfo.isrelase;
        this.removeBtn = this.dataInfo.isrelase;
        // const hasPriv = res.data.object?.hasPriv || '';
        //  const hasPriv = res.data.object.hasPriv;
        const isSuperAdmin = this.$store.state.isSuperAdmin || hasPriv;

        // let privList = this.getUserContextPriv().filter(i => i.classId == this.dataInfo.subClassId).map(j =>j.type);
        // this.addBtnPriv = isSuperAdmin|| privList.includes(17) || hasPriv;
        // this.removeBtnPriv = isSuperAdmin || privList.includes(4) || hasPriv;
        // this.fileBtnPriv = isSuperAdmin || privList.includes(21) || hasPriv;
        // this.fileReadBtnPriv = isSuperAdmin || privList.includes(30) || hasPriv;


        // 附件页签中的添加，删除，下载，预览，四个权限增加了标准，在页面中根据后端的传值，决定是否可用
        this.addBtnPriv = isSuperAdmin || fileAddPriv;
        this.removeBtnPriv = isSuperAdmin || delPriv;
        this.fileBtnPriv = isSuperAdmin || downLoadPriv;
        this.fileReadBtnPriv = isSuperAdmin || previewPriv;

      })

    },

    getPriv() {
      const { isrelase, ...obj_get } = this.dataInfo
      return axios.get(`/pmdm/relationship/hasCustomerPriv${this.params(obj_get)}`,)
    },
  },

  created() {
    this.loadUserPriv();
    this.getAttachments();
    setTimeout(() => {
      this.loading = false;
    }, 500);
  },
  props: ['changeValue', 'dataInfo'],
  watch: {
    changeValue: function (value) {
      this.get_change_info = value;
      this.getAttachments();
    },
    dataInfo: function (value) {
      this.loadUserPriv();
      this.getAttachments();
    }
  }
};
</script>